import PropTypes from 'prop-types';
import NoSSR from 'react-no-ssr';
import Head from 'next/head';

import StyledComponent from '~/components/Styled/Styled';
import GoogleTagManager from '~/components/GoogleTagManager/GoogleTagManager';
import Facebook from '~/components/Facebook/Facebook';
import Salesforce from '~/components/Salesforce/Salesforce';

import css from '~/components/Layout/Layout.scss';
import fonts from '~/static/css/fonts.scss';

import loadCSS from 'fg-loadcss';

const loadCSSAsync = src => {
  if (typeof document !== 'undefined') {
    loadCSS.loadCSS(src);
  }
};

const BixbyLayout = ({ children, title }) => (
  <div id="app-container" className={`${css.container} wrapped-content`}>
    <Head>
      <title>{title}</title>
      <meta charSet="utf-8" />
      <meta property="fb:app_id" content="124052647629735" />
      <meta property="og:site_name" content="theScore.com" />
      <meta name="viewport" content="initial-scale=1.0, width=device-width" />
      <link rel="icon" type="image/png" href="/static/images/favicon.png" />
      {loadCSSAsync('/static/css/grid.css')}
      {loadCSSAsync('/static/css/layout.css')}
      {loadCSSAsync('/static/icons/icons.css')}
    </Head>
    <Salesforce />
    <NoSSR>
      <Facebook />
    </NoSSR>
    <GoogleTagManager />
    <div className={css.container}>
      <div className={css.content}>{children}</div>
    </div>
  </div>
);

BixbyLayout.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
  title: PropTypes.string,
};

BixbyLayout.defaultProps = {
  children: null,
  title: 'theScore',
};

BixbyLayout.displayName = 'BixbyLayout';

export default StyledComponent(BixbyLayout, [css, fonts]);
